<template>
    <section class="col s12">
        <div class="row">
            <div class="col s6">

                <span>A ação possui parcerias externas?</span>
                &nbsp;
                <strong :class="{'green-text' : acaoPossuiParceriasExternas, 'red-text' : !acaoPossuiParceriasExternas}">
                    {{ acaoPossuiParceriasExternas ? 'Sim' : 'Não' }}
                </strong>

            </div>
            <div class=" col s6" v-if="acaoPossuiParceriasExternas">
                <span>A ação possui parcerias externas?</span>
                &nbsp;
                <strong :class="{'green-text' : acaoPossuiParceriasExternas, 'red-text' : !acaoPossuiParceriasExternas}">
                    {{ quantidade_parcerias}}
                </strong>
            </div>
        </div>

        <div class="row" v-if="acaoPossuiParceriasExternas">
            <div class="col s12" v-for="(e, i) in quantidade">
                <div class="card-panel">
                    <div class="row">
                        <h5 class="col s12">
                            Arquivo anexado
                        </h5>
                    </div>
                    <div class="row">
                        <div class="col s12">
                            <span v-if="!retornaAnexosDeParcerias || retornaAnexosDeParcerias.length === 0" class="">Nenhum arquivo anexado...</span>

                            <div v-else style="display: inline;">
                                &nbsp;
                                <a class="btn-flat blue-text"
                                   :download="retornaAnexosDeParcerias[i].nome_anexo"
                                   :href="linkParaDownload(retornaAnexosDeParcerias[i])">
                                    <i class="material-icons left">file_download</i>
                                    {{ retornaAnexosDeParcerias[i].nome_anexo }}
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- VALIDAÇÃO DO ITEM ("OK" OU EM "EXIGÊNCIA") -->
        <div class="row">
            <div class="col s12">
                <p>
                    O item encontra-se "Ok" ou em "Exigência"?
                </p>

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="parcerias_validacao_selecionada"
                               class="with-gap"
                               type="radio"
                               id="rdSimParcValidacaoSelecionada"
                               :disabled="allDisabled"
                               value="ok"
                               v-model="validacaoSelecionada" />
                        <span>Ok</span>
                    </label>
                </div>
                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="parcerias_validacao_selecionada"
                               :disabled="allDisabled"
                               class="with-gap"
                               type="radio"
                               id="rdNaoParcValidacaoSelecionada"
                               value="em_exigencia"
                               v-model="validacaoSelecionada" />
                        <span>Exigência</span>
                    </label>
                </div>
            </div>
        </div>

        <!-- PONTUAÇÃO -->
        <div class="row">
            <div class="input-field col s6">
                <select name="sel_qtd_parcerias_opcao" id="sel_qtd_parcerias_opcao"
                        :disabled="allDisabled"
                        v-model="opcaoSelecionada"
                        @change.stop="selecionaPontuacaoDeAcordoComOpcaoSelecionada"
                        tipo="materialize">
                    <option value="" disabled>Selecione uma opção</option>

                    <option :value="opcaoSelecionada"
                            disabled
                            v-if="opcaoSelecionada && !retornaConfiguracaoSelecionadaPelaOpcao">{{ opcaoSelecionada }}</option>

                    <option v-for="(config, config_i) in configuracaoDeNotas"
                            :key="config_i"
                            :title="config.opcao"
                            :value="config.opcao">{{ config.opcao }}</option>
                </select>
                <label for="sel_qtd_parcerias_opcao">Quantidade de Parcerias</label>
            </div>

            <div class="input-field col s6">
                <input type="text"
                       id="txt_parcerias_pontuacao" name="txt_parcerias_pontuacao"
                       :value="pontuacaoSelecionada != null ? (pontuacaoSelecionada + ' pontos') : 'Não há pontuação definida!'"
                       disabled>
                <label for="txt_parcerias_pontuacao">Pontuação</label>
            </div>
        </div>
    </section>
</template>

<script>
import file_uploads from "../../../utils/file_uploads";

export default {
    name: "at_parcerias",
    props: {
        pAcaoPossuiParceriasExternas: {
            type: Boolean,
            default: false,
        },
        pAnexos: {
            type: Array,
            default: () => { return [] },
        },
        pValidacaoSelecionada: {
            type: String,
            default: null,
        },
        pOpcaoSelecionada: {
            type: String,
            default: null,
        },
        pPontuacaoSelecionada: {
            type: Number,
            default: null,
        },
        configuracaoDeNotas: {
            type: Array,
            default: () => { return [] },
        },
        allDisabled: {
            type: Boolean,
            default: false,
        },
        pQuantidadeParcerias: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            acaoPossuiParceriasExternas: this.pAcaoPossuiParceriasExternas,
            anexos: this.pAnexos,
            opcaoSelecionada: this.pOpcaoSelecionada,
            pontuacaoSelecionada: this.pPontuacaoSelecionada,
            validacaoSelecionada: this.pValidacaoSelecionada,
            quantidade_parcerias: this.pQuantidadeParcerias,

        }
    },
    watch: {
        pOpcaoSelecionada(newValue) {
            this.opcaoSelecionada = newValue
        },
        opcaoSelecionada(newValue) {
            this.$emit('update:pOpcaoSelecionada', newValue)
        },

        pPontuacaoSelecionada(newValue) {
            this.pontuacaoSelecionada = newValue
        },
        pontuacaoSelecionada(newValue) {
            this.$emit('update:pPontuacaoSelecionada', newValue)
        },

        pValidacaoSelecionada(newValue) {
            this.validacaoSelecionada = newValue
        },
        validacaoSelecionada(newValue) {
            this.$emit('update:pValidacaoSelecionada', newValue)
        },
        quantidade_parcerias(newValue) {
            this.$emit('update:pQuantidadeParcerias', newValue)
        }
    },
    computed: {
        quantidade() {
            let l = this.quantidade_parcerias;
            return Array.apply(null, {length: l}).map(Number.call, Number)
        },
        retornaAnexosDeParcerias() {
            if(!this.anexos || this.anexos.length === 0)
                return []

            return _.filter(this.anexos, (anexo) => { return anexo.tipo_de_anexo === 'INSCRICAO_DECLARACOES_DE_PARCERIAS'; })
        },

        retornaConfiguracaoSelecionadaPelaOpcao(){
            if(!this.opcaoSelecionada)
                return null;

            return this.buscaConfiguracaoSelecionadaPelaOpcao()
        },
    },
    methods: {
        linkParaDownload(anexo){
            return file_uploads.linkParaDownloadDeAnexosEmGeral(anexo)
        },

        buscaConfiguracaoSelecionadaPelaOpcao(){
            return _.find(this.configuracaoDeNotas, (config) => {
                return config.opcao === this.opcaoSelecionada;
            });
        },

        selecionaPontuacaoDeAcordoComOpcaoSelecionada(){
            const config = this.buscaConfiguracaoSelecionadaPelaOpcao()

            this.pontuacaoSelecionada = config.pontos
        }
    },
}
</script>

<style scoped>

</style>
